import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";

function VatIdModal({ onClose, onSubmit, initialValues = {} }) {
  const [formData, setFormData] = useState({
    country_id: initialValues.country_id || "",
    vat_no: initialValues.vat_no || "",
    registration_name: initialValues.registration_name || "",
    address: initialValues.address || "",
    city_id: initialValues.city_id || "",
    city: initialValues.city || "",
    provence_region: initialValues.provence_region || "",
    post_code: initialValues.post_code || "",
  });

  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [loadingCountries, setLoadingCountries] = useState(false);
  const [loadingCities, setLoadingCities] = useState(false);

  // Fetch countries
  useEffect(() => {
    const fetchCountries = async () => {
      setLoadingCountries(true);
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE}/getCountries`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
        });
        setCountries(res?.data?.data || []);
      } catch (error) {
        console.error("Error fetching countries:", error);
      } finally {
        setLoadingCountries(false);
      }
    };
    fetchCountries();
  }, []);

  // Fetch cities when country changes
  useEffect(() => {
    const fetchCities = async () => {
      if (!formData.country_id) return;
      setLoadingCities(true);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE}/get-city-by-country/${formData.country_id}`,
          {
            headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
          }
        );
        setCities(res?.data?.data || []);
      } catch (error) {
        console.error("Error fetching cities:", error);
      } finally {
        setLoadingCities(false);
      }
    };
    fetchCities();
  }, [formData.country_id]);

  // Handle change
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "city_id") {
      const cityObj = cities.find((c) => c.id === parseInt(value));
      setFormData((prev) => ({
        ...prev,
        city_id: value,
        city: cityObj ? cityObj.name : "",
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Validation before submit
  const validateForm = () => {
    if (!formData.country_id) {
      toast.error("Please choose a country");
      return false;
    }
    if (!formData.vat_no.trim()) {
      toast.error("VAT ID Number cannot be empty");
      return false;
    }
    if (!formData.registration_name.trim()) {
      toast.error("Name on Registration cannot be empty");
      return false;
    }
    if (!formData.address.trim()) {
      toast.error("Address cannot be empty");
      return false;
    }
    if (!formData.city_id) {
      toast.error("Please choose a city");
      return false;
    }
    if (!formData.provence_region.trim()) {
      toast.error("Province/Region cannot be empty");
      return false;
    }
    if (!formData.post_code.trim()) {
      toast.error("Postcode cannot be empty");
      return false;
    }
    return true;
  };

  // Submit
  const handleSubmit = () => {
    if (!validateForm()) return;

    if (typeof onSubmit === "function") {
      onSubmit(formData);
    }
    if (typeof onClose === "function") {
      onClose();
    }
    toast.success("VAT ID added successfully!");
  };

  return (
    <div
      className="modal fade all_modalss shedowww al_boths show"
      style={{ display: "block" }}
      role="dialog"
      aria-modal="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content detailspgess">
          <div className="modal-header">
            <button type="button" className="close" onClick={onClose}>
              &times;
            </button>
          </div>

          <div className="modal_box checkout">
            <h4>Add VAT ID Number</h4>
            <p className="tx_titls">
              If you are registered with the European Commission, verification may
              take up to 48 hours. We’ll send you an email when it’s finished.
            </p>

            <div className="hlths_area">
              {/* Country */}
              <div className="form-group">
                <label>Country/Region</label>
                <select
                  className="form-control"
                  name="country_id"
                  value={formData.country_id}
                  onChange={handleChange}
                >
                  <option value="">
                    {loadingCountries ? "Loading..." : "Choose country/region"}
                  </option>
                  {countries.map((country) => (
                    <option key={country.id} value={country.id}>
                      {country.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* VAT ID */}
              <div className="form-group">
                <label>VAT ID Number</label>
                <input
                  type="text"
                  className="form-control"
                  name="vat_no"
                  placeholder="Add VAT ID Number"
                  value={formData.vat_no}
                  onChange={handleChange}
                />
              </div>

              {/* Registration Name */}
              <div className="form-group">
                <label>Name on Registration</label>
                <input
                  type="text"
                  className="form-control"
                  name="registration_name"
                  placeholder="Enter name"
                  value={formData.registration_name}
                  onChange={handleChange}
                />
              </div>

              {/* Address */}
              <div className="form-group">
                <label>Address</label>
                <input
                  type="text"
                  className="form-control"
                  name="address"
                  placeholder="Enter Address"
                  value={formData.address}
                  onChange={handleChange}
                />
              </div>

              {/* City */}
              <div className="form-group">
                <label>City</label>
                <select
                  className="form-control"
                  name="city_id"
                  value={formData.city_id}
                  onChange={handleChange}
                  disabled={!formData.country_id || loadingCities}
                >
                  <option value="">
                    {loadingCities
                      ? "Loading cities..."
                      : formData.country_id
                      ? "Choose city"
                      : "Select country first"}
                  </option>
                  {cities.map((city) => (
                    <option key={city.id} value={city.id}>
                      {city.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Province / Region */}
              <div className="form-group">
                <label>Province or Region</label>
                <input
                  type="text"
                  className="form-control"
                  name="provence_region"
                  placeholder="Enter province or region"
                  value={formData.provence_region}
                  onChange={handleChange}
                />
              </div>

              {/* Postcode */}
              <div className="form-group">
                <label>Postcode</label>
                <input
                  type="text"
                  className="form-control"
                  name="post_code"
                  placeholder="Enter Postcode"
                  value={formData.post_code}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Footer */}
            <div className="form-group mb-0">
              <div className="both_areea_btn">
                <button className="clnssel" onClick={onClose} type="button">
                  Close
                </button>
                <button className="btnlinks" onClick={handleSubmit} type="button">
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VatIdModal;
